import { ThemeToggle } from "@/components/theme-toggle";
import { Link } from "react-router-dom";

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100 transition-colors duration-300">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <header className="px-6 py-8 flex justify-between items-center">
          <h1 className="text-xl font-medium">Andre Dias</h1>
          <div className="flex items-center gap-6">
            <nav className="hidden sm:flex items-center gap-6 text-gray-600 dark:text-gray-400">
              <Link to="/" className="hover:text-gray-900 dark:hover:text-white transition-colors">
                home
              </Link>
              <Link to="/about_me" className="hover:text-gray-900 dark:hover:text-white transition-colors">
                about
              </Link>
              <Link to="/projects" className="hover:text-gray-900 dark:hover:text-white transition-colors">
                projects
              </Link>
              <Link to="/blog" className="hover:text-gray-900 dark:hover:text-white transition-colors">
                blog
              </Link>
            </nav>
            <ThemeToggle />
          </div>
        </header>

        {/* Page Content */}
        <main className="px-6 py-16">{children}</main>
      </div>
    </div>
  );
}
